export default "__VITE_ASSET__C678jBbU__"